.multiselectedBg {
  background-color: #ebfefb;
}

.invalidCard {
  border-radius: 8px !important;
  box-shadow: 0 0 0 3px #ff0022 !important;
}
